import jqRequest from '../jqRequest'
import loginUrls from '../urls/login'

export default {
  // 获取手机验证码
  getAuthCode(data) {
    return jqRequest.requestWithToken(loginUrls.getAuthCode, data);
  },
  //  手机验证码登录
  loginByPhone(data) {
    return jqRequest.requestWithContentType(loginUrls.loginByPhone, data, 'post', 'json');
  },
  //  获取用户信息
  getMemberByToken(data) {
    return jqRequest.requestWithTokenAndAuthorization(loginUrls.getMemberByToken, data);
  },
  // 微信授权登录后获取登录信息
  getWeixinMemberInfo(data){
    return jqRequest.requestWithToken(loginUrls.getWeixinMemberInfo, data);
  },
  //  qq登录
  getLoginData(data){
    return jqRequest.requestWithToken(loginUrls.getLoginData, data);
  },
}